// BES-9331: Core types for the shared form-component registry. A registry
// component is defined ONCE here in shared/ and consumed by the dashboard
// editor (block + GrapesJS type), the guest portal (hydration, completeness,
// client PDF), and the backend (extraction, finalize validation, server PDF
// fallback, translation). Legacy components keep their own one-attr-per-type
// markers; everything registry-based uses the generic marker pair below.
/** Marker attribute carrying the registry component type, e.g. "phone-input". */
export const FORM_COMPONENT_TYPE_ATTR = 'data-form-component';
/** Marker attribute carrying the per-instance UUID (minted in the editor's init()). */
export const FORM_COMPONENT_ID_ATTR = 'data-form-component-id';
/** fieldType used when persisting progress values via PATCH /agreements/progress. */
export const FORM_COMPONENT_PROGRESS_FIELD_TYPE = 'form-component';
